import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MeetingTypeResponse } from '../models/meeting.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface MeetingTypeDrawerOptions {
  typeId?: number;
}

@Injectable({ providedIn: 'root' })
export class MeetingTypeDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: MeetingTypeDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly saved$$ = new Subject<MeetingTypeResponse>();

  readonly state = this.state$.asObservable();
  readonly saved$ = this.saved$$.asObservable();

  open(options: MeetingTypeDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(item: MeetingTypeResponse): void {
    this.saved$$.next(item);
  }
}
